
import { HardwareFaultCodeActions, HardwareFaultCodeActionTypes } from '../actions/hardware-fault-code.actions';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {HardwareFaultCodes} from '../../../models/events';

export interface State extends EntityState<HardwareFaultCodes> {
  Loaded: boolean;
  Loading: boolean;
}

export const adapter: EntityAdapter<HardwareFaultCodes> = createEntityAdapter<HardwareFaultCodes>({
  selectId: codeMap => codeMap.ErrorCode
});

export const initialState: State = adapter.getInitialState({
  Loaded: false,
  Loading: false
});

export function reducer(state = initialState, action: HardwareFaultCodeActions): State {
  switch (action.type) {
    case HardwareFaultCodeActionTypes.LoadHardwareFaultCodes:
      return adapter.setAll(action.payload, {...state, Loaded: true, Loading: false});
    case HardwareFaultCodeActionTypes.GetHardwareFaultCodesFails:
      return {...state, Loaded: false, Loading: false};
    case HardwareFaultCodeActionTypes.ChangeLanguageFaultCodes:
      return {...state, Loaded: false, Loading: true};

    default:
      return state;
  }
}
